import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Wrapper = styled.div(
  (props: { inputHeight: string; hideLabel?: boolean }) => css`
    display: grid;
    grid-template-rows: ${props.hideLabel
      ? props.inputHeight
      : '22px ' + props.inputHeight};

    & > span:first-of-type {
      max-width: ${props.hideLabel ? 'nones' : '300px'};
    }
  `
)
